import { render, staticRenderFns } from "./switch.component.vue?vue&type=template&id=a1339d46&scoped=true"
import script from "./switch.component.vue?vue&type=script&lang=js"
export * from "./switch.component.vue?vue&type=script&lang=js"
import style0 from "./switch.component.vue?vue&type=style&index=0&id=a1339d46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1339d46",
  null
  
)

export default component.exports